// hooks/useTipos.js
import { useEffect, useState } from "react";
import { GET_FILE_TYPES } from "../api/apiEmpresas";

export const useTipos = (tipo) => {
  const [texto, setTexto] = useState("cargando...");

  useEffect(() => {
    const fetchTipos = async () => {
      try {
        const fileData = await GET_FILE_TYPES();
        const documentoEncontrado = fileData?.find(
          (doc) => doc?.tableName === tipo
        );
        setTexto(documentoEncontrado ? documentoEncontrado?.name : "Documento no encontrado");
      } catch (error) {
        console.error(error);
        setTexto("Documento no encontrado");
      }
    };

    if (tipo) fetchTipos();
  }, [tipo]);

  return texto;
};
